import { __ } from '@wordpress/i18n';
import { Textarea } from '@woocommerce/blocks-components';
import { useDispatch } from '@wordpress/data';
import { VALIDATION_STORE_KEY } from '@woocommerce/block-data';
import { ValidationInputError } from '@woocommerce/blocks-components';
import { useEffect } from 'react';
import clsx from 'clsx';

const TextareaField = ({ field, value, onChange, required }) => {

    const { id, title, cssclass } = field;
    const errorId = `section_${id}`;

    const { setValidationErrors, clearValidationError } =
        useDispatch(VALIDATION_STORE_KEY);

    useEffect(() => {
        if (!required || value) {
            clearValidationError(errorId);
        } else {
            setValidationErrors({
                [errorId]: {
                    message: __('This field is required.', 'woocommerce-checkout-field-editor-pro'),
                    hidden: true,
                },
            });
        }

        return () => {
            clearValidationError(errorId);
        };
    }, [value, required]);

    return (
        <div
            id={id} 
            className={clsx(
                'wc-block-components-text-input',
                'thwcfe-textarea-wrapper',
                value?.length ? 'is-active' : '',
                cssclass?.split(',').map(c => c.trim())
            )}
        >
            <Textarea
                id={id}
                disabled={false}
                placeholder=""
                value={value || ''}
                onTextChange={(text) => {
                    onChange(text);
                }}
            />

            {title && <label htmlFor={id}>{title}</label>}

            <ValidationInputError propertyName={errorId} />
        </div>
    );
};

export default TextareaField;